/**
 * Map an enrollment status to a Quasar color so the students-list chip carries
 * meaning instead of being uniformly yellow.
 *
 * Statuses: pending | active | dropped | completed | declined (see the backend
 * enrollment schema). Unknown/empty falls back to a neutral grey.
 */
export function enrollmentStatusColor(status?: string): string {
  switch ((status || '').toLowerCase()) {
    case 'active':
      return 'positive';
    case 'pending':
      return 'warning';
    case 'dropped':
    case 'declined':
      return 'negative';
    case 'completed':
      return 'info';
    default:
      return 'grey-5';
  }
}
